// extracted by mini-css-extract-plugin
module.exports = {"option":"_6ef38a6"};